import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

const AnimatedSection = ({ 
  children, 
  delay = 0, 
  duration = 0.8,
  animationType = 'fadeUp', // 'fadeUp', 'fadeIn', 'slideLeft', 'slideRight'
  ...props 
}) => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  const getAnimationStyle = () => {
    const baseStyle = {
      transition: `all ${duration}s cubic-bezier(0.4, 0, 0.2, 1) ${delay}s`,
    };

    switch (animationType) {
      case 'fadeUp':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(60px)',
        };
      case 'fadeIn':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
        };
      case 'slideLeft':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateX(0)' : 'translateX(60px)',
        };
      case 'slideRight':
        return {
          ...baseStyle,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateX(0)' : 'translateX(-60px)',
        };
      default:
        return baseStyle;
    }
  };

  return (
    <div ref={ref} style={getAnimationStyle()} {...props}>
      {children}
    </div>
  );
};

export default AnimatedSection;